import vue from 'vue'
import { getHeadersWithAccessToken } from '../../functions'
import axios from '../../services/axios'
const state = {
    powerHours: {},
    ticketsOpen: undefined,
    powerHoursType: 'Last 6 months',
    powerHoursGraphData: []
}

const mutations = {
    'SET_POWERHOURS_DATA' (state, payload) {
        vue.set(state, 'powerHours', payload)
    },
    'SET_GRAPH_DATA' (state, payload) {
        vue.set(state, 'powerHoursGraphData', payload)
    }
}

const actions = {
    getPowerHoursGraphData: ({ commit, rootState }, payload) => {
        let params = { 'format': 'aod', 'store_id': payload }
        return axios.post(((rootState.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/performance/powerhours/weekdaygraph', params, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_GRAPH_DATA', response.data)
            })
            .catch(error => {
                console.log(error)
            })
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
